import { render, staticRenderFns } from "./TabShipmentPlanningNew.vue?vue&type=template&id=60f3be00&scoped=true"
import script from "./TabShipmentPlanningNew.vue?vue&type=script&lang=js"
export * from "./TabShipmentPlanningNew.vue?vue&type=script&lang=js"
import style0 from "./TabShipmentPlanningNew.vue?vue&type=style&index=0&id=60f3be00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3be00",
  null
  
)

export default component.exports